import type { IssueAssignee } from '@momentum/types';
import type { Employee } from '@momentum/types';

/**
 * Type guard to check if an assignee has valid personalInfo
 */
export const hasValidPersonalInfo = (
  assignee: IssueAssignee | Employee | undefined | null
): assignee is IssueAssignee & {
  personalInfo: NonNullable<IssueAssignee['personalInfo']>;
} => {
  return !!assignee?.personalInfo;
};

/**
 * Get the full name from an assignee or employee, safely handling missing personalInfo
 */
export const getFullName = (
  assignee: IssueAssignee | Employee | undefined | null
): string | null => {
  if (!hasValidPersonalInfo(assignee)) {
    return null;
  }
  return (
    `${assignee.personalInfo.firstName || ''} ${
      assignee.personalInfo.lastName || ''
    }`.trim() || null
  );
};

/**
 * Filter an array of assignees/employees to only include those with valid personalInfo
 */
export const filterValidAssignees = <T extends IssueAssignee | Employee>(
  assignees: (T | undefined | null)[]
): T[] => {
  return assignees.filter(hasValidPersonalInfo) as T[];
};
